<template>
    <div>
        <div class="banner">
            <div class="headerReplacementNewInfo"></div>
            <div class="banner-text">
                <b>ข่าวแจ้งตลาดหลักทรัพย์</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>ห้องข่าว</span>
                    <span class="separator"></span>
                    <span><b>ข่าวแจ้งตลาดหลักทรัพย์</b></span>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="TabMenu">
                <NewInfoTabMenu />
            </div>

            <div class="row g-3 justify-content-center align-items-center mt-3 mb-5">
                <div class="col-md-auto">
                    <label class="col-form-label">ค้นหา</label>
                </div>
                <div class="col-md-6 position-relative">
                    <input type="text" class="form-control pe-5" v-model="searchQuery" placeholder="ค้นหา">
                    <i class="fas fa-search position-absolute top-50 end-0 translate-middle-y me-3"></i>
                </div>
                <div class="col-md-auto">
                    <label class="col-form-label">เลือกปี</label>
                </div>
                <div class="col-md-2">
                    <select v-model="selectedYear" id="yearSelect" class="form-select" aria-label="Year selection">
                        <option value="2025">2025</option>
                        <option value="2024">2024</option>
                        <option value="2023">2023</option>
                        <option value="2022">2022</option>
                        <option value="2021">2021</option>
                    </select>
                </div>
            </div>

            <!-- News Articles List -->
            <div class="container mt-5 mb-5">
                <!-- News List -->
                <div v-for="(item, index) in paginatedList" :key="index" class="row border-bottom g-2 mb-3">
                    <div class="col-6 text-start mb-3">
                        <div>
                            <span class="fw-bold">{{ item.new_set_title }}</span>
                        </div>
                        <div>
                            <span class="text-secondary"><small> {{ item.new_set_date }} </small></span>
                        </div>
                    </div>

                    <div class="col-6 text-end">
                        <div class="text-secondary">
                            <a :href="item.new_set_pdf_url" target="_blank"><small>อ่านเพิ่มเติม</small></a>
                        </div>
                    </div>
                </div>

                <!-- Loading Spinner (Centered) -->
                <div v-if="isLoading" class="d-flex justify-content-center align-items-center" style="height: 100px;">
                    <div class="spinner-grow custom-spinner" role="status"></div>
                </div>

                <!-- Pagination Controls -->
                <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center">
                        <li class="page-item" :class="{ 'disabled': currentPage === 1 }">
                            <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
                        </li>

                        <!-- Show first page, then "..." if needed -->
                        <li class="page-item" v-if="currentPage > 2">
                            <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
                        </li>

                        <li class="page-item" v-if="currentPage > 3">
                            <span class="page-link">...</span>
                        </li>

                        <!-- Show pages around the current page -->
                        <li class="page-item" :class="{ 'active': currentPage === page }" v-for="page in visiblePages" :key="page">
                            <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                        </li>

                        <!-- Show "..." before the last pages if needed -->
                        <li class="page-item" v-if="currentPage < totalPages - 2">
                            <span class="page-link">...</span>
                        </li>

                        <li class="page-item" v-if="currentPage < totalPages - 1">
                            <a class="page-link" href="#" @click.prevent="changePage(totalPages)">{{ totalPages }}</a>
                        </li>

                        <li class="page-item" :class="{ 'disabled': currentPage === totalPages }">
                            <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    </div>
</template>

<script>
import NewInfoTabMenu from '@/components/NewInfoTabMenu.vue';
import store from "@/store";
import { GET_SET_STOCK_NEWS_DATA } from "../../store/actions.type";
import dayjs from 'dayjs';

export default {
    name: 'Info',
    components: {
        NewInfoTabMenu,
    },
    data() {
        return {
            list: [],
            isLoading: false,
            currentPage: 1,
            itemsPerPage: 10,
            searchQuery: '',
            selectedYear: '2025',
        };
    },
    async created() {
        this.isLoading = true;
        await this.init();
        this.isLoading = false;
    },
    computed: {
        totalPages() {
            return Math.ceil(this.filteredList.length / this.itemsPerPage);
        },
        visiblePages() {
            const pages = [];
            let start = Math.max(1, this.currentPage - 2);
            let end = Math.min(this.totalPages, this.currentPage + 2);

            // Ensure that the pages array contains a logical page range based on filtered results
            if (this.totalPages <= 1) return [];

            for (let i = start; i <= end; i++) {
                pages.push(i);
            }

            return pages;
        },
        filteredList() {
            return this.list.filter(item => {
                const year = dayjs(item.new_set_date).year().toString();
                return (
                    (this.selectedYear === 'all' || year === this.selectedYear) &&
                    item.new_set_title.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            });
        },
        paginatedList() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            const end = start + this.itemsPerPage;
            return this.filteredList.slice(start, end);
        },
    },
    methods: {
        async init() {
            try {
                this.list = await store.dispatch(GET_SET_STOCK_NEWS_DATA);
                console.log(this.list);
                this.list = this.list.sort((a, b) => b.new_set_id - a.new_set_id);
            } catch (error) {
                console.error("Error fetching news data:", error);
            }
        },
        formatDate(dateString) {
            return dayjs(dateString).format('DD MMMM YYYY');
        },
        changePage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },
    },
};
</script>

<style scoped>
th {
    font-weight: normal;
}

.table {
    margin-bottom: 0;
}

.table th {
    font-size: 0.85rem;
    font-weight: normal;
    padding: 8px;
}
</style>
